import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=0155f2c6&scoped=true&"
import script from "./FeaturesSection.vue?vue&type=script&lang=js&"
export * from "./FeaturesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0155f2c6",
  null
  
)

export default component.exports